import type { Ref } from 'vue'
import { ref } from 'vue'

import { useTeamStore } from '@/pinia/useTeamStore'
import { loadCreditUsage } from '@/backend/darwin/loadCreditUsage'
import { useToast } from '@/uiKit/Toast/useToast'
import { useCreditUsageStore } from './useCreditUsageStore'

export const useCreditUsageLoader = (): {
  loading: Ref<boolean>
  loadUsage: () => Promise<void>
} => {
  const teamStore = useTeamStore()
  const loading = ref(false)
  const toast = useToast()
  const usageStore = useCreditUsageStore()

  const loadUsage = async (): Promise<void> => {
    if (!teamStore.currentTeam) {
      return
    }

    loading.value = true
    const result = await loadCreditUsage({ teamSlug: teamStore.currentTeam.slug })
    loading.value = false

    if (result.ok) {
      usageStore.creditUsage = result.data
    } else {
      toast.warning({ meta: { title: result.error.message.toString() } })
    }
  }

  return {
    loading,
    loadUsage,
  }
}
